module.exports = __webpack_public_path__ + "img/task-m1.f8a0ed3c.jpeg";